import HniBanner from './HniBanner';
import HniSection from './HniSection';

function Hni() {
  return (
    <div>
      <HniBanner />
      <HniSection />
    </div>
  );
}

export default Hni;